/**
 * ULID canónico (docs/esquema.md §3): el Worker genera ids para catálogos y
 * dispositivos; los eventos los genera el dispositivo. Identificador OPACO:
 * su componente temporal no se usa para ordenar ni autorizar.
 */

const ALFABETO_CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

export function generarUlid(ahoraMs = Date.now()): string {
	// 48 bits de timestamp en 10 chars (base 32).
	let tiempo = '';
	let restante = ahoraMs;
	for (let i = 0; i < 10; i++) {
		tiempo = ALFABETO_CROCKFORD[restante % 32] + tiempo;
		restante = Math.floor(restante / 32);
	}
	// 80 bits aleatorios en 16 chars: 16 bytes dan 16 valores uniformes 0..31
	// tomando 5 bits de cada uno (sesgo cero: 256 = 8 × 32).
	const azar = crypto.getRandomValues(new Uint8Array(16));
	let resto = '';
	for (let i = 0; i < 16; i++) {
		resto += ALFABETO_CROCKFORD[azar[i] % 32];
	}
	return tiempo + resto;
}
